import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import Dialog from '../Dialog/Dialog';
import styles from './NoLoginSubscribe.module.less';
import { handleCancelShow, cancelSubscribe, setNoLoginAppSubscribe } from '../../actions/layout';
import { createAxios } from '../../utils/utils';
import { SUBSCRIBE_REPOET_87 } from '../../config/index';
import Toast from '../Toast/Toast';
import { logging } from '../../actions/log';
import { handleLogin } from '../../utils/hooks/useLoginStatus';

const selectNologinSubscribeShow = createSelector(
  state => state.layout,
  layout => layout.noLoginSubscribe,
);

export default memo(() => {
  const dispatch = useDispatch();
  const noLoginShow = useSelector(selectNologinSubscribeShow);
  let cancelStyle = styles.cancel_g;
  let noCancelStyle = styles.no_cancel_g;
  if (noLoginShow?.style === 'black' || noLoginShow?.style === 'opacity') {
    cancelStyle = styles.cancel_b;
    noCancelStyle = styles.no_cancel_b;
  }

  useEffect(() => {
    // return () => {
    //   dispatch(setNoLoginAppSubscribe({ isShow: false, softId: null, style: null }));
    // };
  }, []);

  const handleCancelDialog = info => {
    dispatch(setNoLoginAppSubscribe({ isShow: false, softId: null, style: null }));
  };

  const handleSubscribeLogin = () => {
    dispatch(setNoLoginAppSubscribe({ isShow: false, softId: noLoginShow.softId, style: null }));
    handleLogin();
  };

  return (
    <Dialog
      title="温馨提示"
      maskStyle={styles.mask}
      containerStyle={styles.containerStyle}
      handleClose={() => handleCancelDialog(1)}
    >
      <div className={styles.cancel_desc}>
        该游戏当前为删测版本，登录账号后即可预约该游戏的正式版
      </div>
      <div className={styles.cancel_control}>
        <div className={cancelStyle} onClick={() => handleCancelDialog(2)}>
          取消
        </div>
        <div className={noCancelStyle} onClick={() => handleSubscribeLogin()}>
          去登录
        </div>
      </div>
    </Dialog>
  );
});
